package com.macrofocus.eflux.data.quest

import com.macrofocus.eflux.data.*
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.AccessorRowMajorDataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame

/**
 * Parsing of Power Flow Raw Data files
 */
class QuestPowerFlowParser constructor(zones: DataFrame<Int,String,Any?>, buses: DataFrame<Int,String,Any?>, branches: DataFrame<Int,String,Any?>) : PowerFlowParser {
    override val busDataFrame: AccessorRowMajorDataFrame<BusPowerFlowRecord, RowMajorDataFrame.Column<BusPowerFlowRecord, Any?>, Any?> =
        AccessorRowMajorDataFrame<BusPowerFlowRecord, RowMajorDataFrame.Column<BusPowerFlowRecord, Any?>, Any?>(
            BusPowerFlowColumn.all.filterIsInstance<RowMajorDataFrame.Column<BusPowerFlowRecord, Any?>>().toTypedArray()
        )
    override val loadDataFrame: AccessorRowMajorDataFrame<LoadPowerFlowRecord, RowMajorDataFrame.Column<LoadPowerFlowRecord, Any?>, Any?>? =
        null
    override val generatorDataFrame: AccessorRowMajorDataFrame<GeneratorPowerFlowRecord, RowMajorDataFrame.Column<GeneratorPowerFlowRecord, Any?>, Any?>? =
        null
    override val branchDataFrame: AccessorRowMajorDataFrame<BranchPowerFlowRecord, RowMajorDataFrame.Column<BranchPowerFlowRecord, Any?>, Any?> =
        AccessorRowMajorDataFrame<BranchPowerFlowRecord, RowMajorDataFrame.Column<BranchPowerFlowRecord, Any?>, Any?>(
            BranchPowerFlowColumn.all.filterIsInstance<RowMajorDataFrame.Column<BranchPowerFlowRecord, Any?>>().toTypedArray()
        )
    override val transformerDataFrame: AccessorRowMajorDataFrame<TransformerPowerFlowRecord, RowMajorDataFrame.Column<TransformerPowerFlowRecord, Any?>, Any?>? =
        null
    override val zoneDataFrame: AccessorRowMajorDataFrame<ZonePowerFlowRecord, RowMajorDataFrame.Column<ZonePowerFlowRecord, Any?>, Any?> =
        AccessorRowMajorDataFrame<ZonePowerFlowRecord, RowMajorDataFrame.Column<ZonePowerFlowRecord, Any?>, Any?>(
            ZonePowerFlowColumn.all.filterIsInstance<RowMajorDataFrame.Column<ZonePowerFlowRecord, Any?>>().toTypedArray()
        )

    init {
        for (row in zones.rows()) {
            zoneDataFrame.addRow(QuestZonePowerFlowRecord(zones, row))
        }

        for (row in buses.rows()) {
            busDataFrame.addRow(QuestBusPowerFlowRecord(buses, row))
        }

        for (row in branches.rows()) {
            branchDataFrame.addRow(QuestBranchPowerFlowRecord(branches, row))
        }
    }
}

